/**
 * Where a newcomer is on the way from the invitation to a running bot (owner,
 * 2026-10-29): five steps, each opened only by the one before it.
 */
import { Check } from "lucide-react";

export const STEPS = ["Приглашение", "Аккаунт", "Bybit", "Telegram", "Запуск"] as const;

/** `current` is the step being worked on, from 0; the ones before it are done. */
export function Steps({ current }: { readonly current: number }): React.JSX.Element {
  return (
    <ol className="flex w-full flex-wrap items-center gap-x-2 gap-y-2" aria-label="Шаги подключения" data-testid="onboarding-steps">
      {STEPS.map((title, index) => {
        const done = index < current;
        const now = index === current;
        return (
          <li key={title} className="flex items-center gap-2" aria-current={now ? "step" : undefined}>
            <span
              className={`flex size-7 shrink-0 items-center justify-center rounded-full text-helper-sm font-medium ${
                done
                  ? "bg-status-positive text-text-on-action"
                  : now
                    ? "bg-action-primary text-text-on-action"
                    : "border border-border-strong text-text-muted"
              }`}
            >
              {done ? <Check aria-hidden="true" className="size-4" /> : index + 1}
            </span>
            <span className={`text-helper-sm ${now ? "font-medium text-text-primary" : "text-text-muted"}`}>{title}</span>
            {index < STEPS.length - 1 && <span aria-hidden="true" className="hidden h-px w-6 bg-border-strong sm:block" />}
          </li>
        );
      })}
    </ol>
  );
}
